// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + (chunkId === 66586 ? "griffel" : chunkId) + "-" + {"7730":"6cdeac8d49","35072":"fb5940289a","66586":"ee09dd1e43","90062":"9cd2058a69"}[chunkId] + ".css";
};